// Anita Week 9 / Day 5 — Creator Project: My Useful Content.
// Verbatim from FINAL Week 9 Part B (Creator) source-of-truth package.

const day5 = {
  id: 'day-5',
  studentId: 'anita',
  weekId: 'week-9',
  dayId: 'day-5',
  status: 'active',
  title: 'Авторский проект: мой полезный контент / Creator Project: My Useful Content',
  shortTitle: 'Мой полезный контент / My Useful Content',
  theme: 'Анита создаёт полезный бумажный проект и объясняет, кому он поможет, что он объясняет и почему он безопасен. / Anita creates a useful paper project and explains whom it helps, what it teaches and why it is safe.',
  estimatedTimeLabel: '60–90 минут / 60–90 minutes',
  lessonTiming: { minMinutes: 60, maxMinutes: 90, breaks: 2 },
  bilingualMode: 'ru-primary-en-helper',
  readingLevel: 'grade-2',
  courseLayers: ['reading', 'math', 'creator-project', 'presentation', 'safety', 'spelling', 'speech'],
  nimnyIntro:
    'Нимни открывает Паспорт автора. Сегодня Анита не просто отвечает на вопросы — она создаёт полезный контент: постер, мини-гайд, карточку проверки, рисунок-инструкцию или короткий сценарий объяснения. В конце она даст обещание автора. / Nimny opens the Creator Passport. Today Anita does not just answer questions — she creates useful content: a poster, mini-guide, checking card, drawing-instruction or short explanation script. At the end she gives a creator promise.',
  goals: [
    'Повторить путь Зритель → Автор. / Review User → Creator.',
    'Выбрать полезную тему проекта. / Choose a useful project topic.',
    'Создать бумажный полезный контент. / Create useful paper content.',
    'Проверить проект по Чек-лист автора. / Check the project with Creator Checklist.',
    'Решить math review с планом проекта. / Solve project planning math review.',
    'Провести короткую презентацию родителю. / Present to parent.'
  ],
  vocabulary: [
    { term: 'автор / creator', definition: 'автор полезного. / a creator of useful things.' },
    { term: 'польза / value', definition: 'чем проект помогает. / how the project helps.' },
    { term: 'аудитория / audience', definition: 'кому это поможет. / who it will help.' },
    { term: 'черновик / draft', definition: 'первая версия. / the first version.' },
    { term: 'исправить / revise', definition: 'улучшить. / make it better.' },
    { term: 'честно / honest', definition: 'без обмана. / without deception.' },
    { term: 'понятно / clear', definition: 'легко понять. / easy to understand.' },
    { term: 'безопасно / safe', definition: 'без личных данных и вреда. / without personal data or harm.' },
    { term: 'обещание / promise', definition: 'что я обещаю как creator. / what I promise as a creator.' }
  ],
  onlineTasks: [
    { id: 'reading-review-words', type: 'text', title: 'Задание 1 — Слова автора / Creator Words Review',
      prompt: 'Прочитай слова недели:\n\ncreator\nпольза\nаудитория\nчерновик\nисправить\nчестно\nпонятно\nбезопасно\nобещание',
      ruPrimaryText: 'Прочитай 9 слов недели автора.',
      enHelpText: 'Read the Russian creator words first. English is only for help.',
      answer: 'Attempted Russian reading.' },
    { id: 'oral-defense-reading', type: 'text', title: 'Задание 2 — Фразы автора / Creator Phrases',
      prompt: 'Прочитай и попробуй сказать по-русски:\n\n1. Я не только пользователь.\n2. Я могу создать полезное.\n3. Я думаю, кому это поможет.\n4. Я делаю черновик и исправляю.\n5. Я проверяю: честно, понятно, полезно, безопасно.',
      ruPrimaryText: 'Прочитай и попробуй сказать 5 фраз автора по-русски.',
      enHelpText: 'I am not only a user. I can create something useful. I think who it helps. I make a draft and revise. I check: honest, clear, useful, safe.',
      answer: 'Attempted Russian reading and/or oral speaking.' },
    { id: 'project-topic-choice', type: 'classify', title: 'Задание 3 — Выбери тему проекта / Choose a Project Topic',
      prompt: 'Выбери или разложи темы по категориям.\n\nКатегории:\nХорошая тема для полезного контента\nНужно проверить с родителем\nНе использовать\n\nТемы:\n1. Как попросить помощи, если потерялась.\n2. Как проверить рекламу.\n3. Как измерить предмет линейкой.\n4. Как нарисовать безопасный маршрут Нимни.\n5. Как написать настоящий домашний адрес.\n6. Как сделать постер «стоп — уйти — рассказать».\n7. Как создать пароль и показать его всем.\n8. Как отличить полезную привычку от отвлечения.\n9. Как наблюдать природу из окна.\n10. Как написать сообщение незнакомцу.\n11. Как придумать честную бизнес-идею.\n12. Как сделать мини-гайд для младшего ребёнка.',
      ruPrimaryText: 'Разложи 12 тем: хорошая / проверить с родителем / не использовать.',
      enHelpText: 'Sort 12 project topics: good / needs parent check / not allowed.',
      categories: [
        { id: 'good', label: 'Хорошая тема / Good topic' },
        { id: 'parent', label: 'Нужно проверить с родителем / Needs parent check' },
        { id: 'forbidden', label: 'Не использовать / Not allowed' }
      ],
      items: [
        { id: 't1', label: '1. Как попросить помощи, если потерялась.', category: 'good' },
        { id: 't2', label: '2. Как проверить рекламу.', category: 'good' },
        { id: 't3', label: '3. Как измерить предмет линейкой.', category: 'good' },
        { id: 't4', label: '4. Как нарисовать безопасный маршрут Нимни.', category: 'good' },
        { id: 't5', label: '5. Как написать настоящий домашний адрес.', category: 'forbidden' },
        { id: 't6', label: '6. Как сделать постер «стоп — уйти — рассказать».', category: 'good' },
        { id: 't7', label: '7. Как создать пароль и показать его всем.', category: 'forbidden' },
        { id: 't8', label: '8. Как отличить полезную привычку от отвлечения.', category: 'good' },
        { id: 't9', label: '9. Как наблюдать природу из окна.', category: 'good' },
        { id: 't10', label: '10. Как написать сообщение незнакомцу.', category: 'forbidden' },
        { id: 't11', label: '11. Как придумать честную бизнес-идею.', category: 'good' },
        { id: 't12', label: '12. Как сделать мини-гайд для младшего ребёнка.', category: 'good' }
      ],
      answer: 'Хорошая тема: 1, 2, 3, 4, 6, 8, 9, 11, 12. Не использовать: 5, 7, 10. (2, 11, 12 могут быть «проверить с родителем» в зависимости от глубины.)' },
    { id: 'math-project-plan', type: 'text', title: 'Задание 4 — Математика проекта / Project Math',
      prompt: 'У проекта 8 разделов:\n1. Название\n2. Кому поможет\n3. Что объясняет\n4. 3 главных шага\n5. Один пример\n6. Почему полезно\n7. Чек-лист автора\n8. Обещание автора\n\nАнита уже сделала 5 разделов.\n\nОтветь:\n1. Сколько разделов осталось?\n2. Если каждый оставшийся раздел занимает 6 минут, сколько минут нужно?\n3. Если Анита работает 2 дня по 10 минут, хватит ли времени?\n4. Сколько минут останется?',
      ruPrimaryText: 'Реши 4 задачи про план проекта на 8 разделов.',
      enHelpText: 'Solve 4 project-plan problems.',
      answer: '1) 8 − 5 = 3. 2) 3 × 6 = 18 минут. 3) 2 × 10 = 20 минут. Хватит. 4) 20 − 18 = 2 минуты останется.' },
    { id: 'math-content-cards', type: 'text', title: 'Задание 5 — Карточки контента / Content Cards',
      prompt: 'Анита делает 5 карточек.\nНа каждой карточке по 4 короткие фразы.\nПотом она добавляет ещё 6 рисунков.\nПосле проверки родитель просит убрать 2 слишком длинные фразы.\n\nОтветь:\n1. Сколько фраз было сначала?\n2. Сколько всего фраз и рисунков было до исправления?\n3. Сколько фраз осталось после исправления?\n4. Если 18 коротких фраз разделить на 6 карточек, сколько фраз на каждой?',
      ruPrimaryText: 'Реши 4 задачи про карточки контента.',
      enHelpText: 'Solve 4 content-card problems.',
      answer: '1) 5 × 4 = 20. 2) 20 + 6 = 26. 3) 20 − 2 = 18. 4) 18 ÷ 6 = 3.' },
    { id: 'creator-project-planner', type: 'project', title: 'Задание 6 — План моего полезного контента / My Useful Content Planner',
      prompt: 'Создай проект «Мой полезный контент».\n\nВыбери один формат:\n□ постер\n□ мини-гайд\n□ карточка проверки\n□ рисунок-инструкция\n□ короткий сценарий объяснения\n□ маленькая презентация\n\nЗаполни 8 разделов:\n1. Название проекта: ______\n2. Кому поможет: ______\n3. Что объясняет: ______\n4. 3 главных шага: ______\n5. Один пример: ______\n6. Почему это полезно: ______\n7. Чек-лист автора: честно / понятно / полезно / безопасно\n8. Обещание автора: ______',
      ruPrimaryText: 'Сделай Авторский проект «Мой полезный контент» с 8 разделами на бумаге.',
      enHelpText: 'Build the 8-section Авторский проект: title, audience, what, 3 steps, example, why useful, checklist, promise.',
      answer: 'Open-ended. Project should include most sections and a safe/useful purpose.' },
    { id: 'creator-safety-final-sort', type: 'classify', title: 'Задание 7 — Финальная проверка безопасности / Final Safety Check',
      prompt: 'Разложи карточки перед презентацией проекта.\n\nКатегории:\nМожно оставить\nНужно спросить родителя\nУбрать из проекта\n\nКарточки:\n1. Роль «родитель» вместо настоящего имени.\n2. Настоящий адрес.\n3. Фраза «спроси взрослого».\n4. Красивое обещание «это поможет всем всегда».\n5. Рисунок Нимни.\n6. Настоящее фото ребёнка.\n7. Проверочный вопрос «это безопасно?»\n8. Название школы.\n9. 3 понятных шага.\n10. Секретный пароль.\n11. Добрые слова.\n12. Показ проекта родителю.',
      ruPrimaryText: 'Разложи 12 карточек перед презентацией: оставить / спросить родителя / убрать.',
      enHelpText: 'Sort 12 cards before the presentation: keep / ask parent / remove.',
      categories: [
        { id: 'keep', label: 'Можно оставить / Keep' },
        { id: 'parent', label: 'Нужно спросить родителя / Ask parent' },
        { id: 'remove', label: 'Убрать из проекта / Remove' }
      ],
      items: [
        { id: 's1', label: '1. Роль «родитель» вместо настоящего имени.', category: 'keep' },
        { id: 's2', label: '2. Настоящий адрес.', category: 'remove' },
        { id: 's3', label: '3. Фраза «спроси взрослого».', category: 'keep' },
        { id: 's4', label: '4. Красивое обещание «это поможет всем всегда».', category: 'parent' },
        { id: 's5', label: '5. Рисунок Нимни.', category: 'keep' },
        { id: 's6', label: '6. Настоящее фото ребёнка.', category: 'remove' },
        { id: 's7', label: '7. Проверочный вопрос «это безопасно?»', category: 'keep' },
        { id: 's8', label: '8. Название школы.', category: 'remove' },
        { id: 's9', label: '9. 3 понятных шага.', category: 'keep' },
        { id: 's10', label: '10. Секретный пароль.', category: 'remove' },
        { id: 's11', label: '11. Добрые слова.', category: 'keep' },
        { id: 's12', label: '12. Показ проекта родителю.', category: 'keep' }
      ],
      answer: 'Keep: 1, 3, 5, 7, 9, 11, 12. Ask parent: 4. Remove: 2, 6, 8, 10.' },
    { id: 'spelling-review', type: 'text', title: 'Задание 8 — Правописание недели / Week Spelling',
      prompt: 'Напиши 6 слов на выбор:\n\nавтор\nпольза\nаудитория\nчерновик\nчестно\nпонятно\nполезно\nбезопасно\nобещание',
      ruPrimaryText: 'Напиши 6 слов недели на выбор.',
      enHelpText: 'Write any 6 of the week-words.',
      answer: 'Any 6 attempted words. Parent checks gently.' },
    { id: 'speech-creator-presentation', type: 'text', title: 'Задание 9 — Защита проекта / Project Presentation',
      prompt: 'Объясни родителю по-русски:\n\n1. Какой проект ты сделала?\n2. Кому он поможет?\n3. Что он объясняет?\n4. Почему он полезный?\n5. Как ты проверила: честно, понятно, полезно, безопасно?',
      ruPrimaryText: 'Объясни проект родителю по-русски: 5 вопросов.',
      enHelpText: 'Explain the project to parent in Russian: 5 questions.',
      answer: 'Accept if Anita explains project, audience, usefulness and creator check in Russian with support.' }
  ],
  notebookInstructions: [
    'Если нет принтера:',
    '1. Напиши название «Мой полезный контент».',
    '2. Напиши 6 слов недели.',
    '3. Прочитай 5 фраз автора.',
    '4. Реши 2 math-задачи.',
    '5. Выбери формат проекта.',
    '6. Заполни 8 разделов.',
    '7. Проверь безопасность проекта.',
    '8. Объясни проект родителю.'
  ],
  printWorksheet: {
    title: 'Авторский проект: мой полезный контент / Creator Project: My Useful Content',
    subtitle: 'Неделя 9 · День 5 / Week 9 · Day 5',
    pages: [
      { title: 'Авторский проект / Мой полезный контент',
        blocks: [
          { type: 'text', text: 'Имя: __________________________   Дата: __________________________' },
          { type: 'text', text: 'Миссия: Сегодня ты создаёшь полезный бумажный проект. Ты не просто пользователь. Ты creator.' },
          { type: 'text', text: 'Задание 1 — Слова автора. Прочитай и обведи:' },
          { type: 'list', items: [
            'creator / creator',
            'польза / value',
            'аудитория / audience',
            'черновик / draft',
            'исправить / revise',
            'честно / honest',
            'понятно / clear',
            'безопасно / safe',
            'обещание / promise'
          ] },
          { type: 'text', text: 'Задание 2 — Фразы автора. Поставь галочку:' },
          { type: 'list', items: [
            '□ Я не только пользователь.',
            '□ Я могу создать полезное.',
            '□ Я думаю, кому это поможет.',
            '□ Я делаю черновик и исправляю.',
            '□ Я проверяю: честно, понятно, полезно, безопасно.'
          ] },
          { type: 'text', text: 'Задание 3 — Выбери тему проекта. A = хорошая тема, B = нужно спросить родителя, C = не использовать.' },
          { type: 'list', items: [
            '1. Как попросить помощи, если потерялась. ____',
            '2. Как проверить рекламу. ____',
            '3. Как измерить предмет линейкой. ____',
            '4. Как нарисовать безопасный маршрут Нимни. ____',
            '5. Как написать настоящий домашний адрес. ____',
            '6. Как сделать постер «стоп — уйти — рассказать». ____',
            '7. Как создать пароль и показать его всем. ____',
            '8. Как отличить полезную привычку от отвлечения. ____',
            '9. Как наблюдать природу из окна. ____',
            '10. Как написать сообщение незнакомцу. ____',
            '11. Как придумать честную бизнес-идею. ____',
            '12. Как сделать мини-гайд для младшего ребёнка. ____'
          ] }
        ] },
      { title: 'Математика и план / Math and Plan',
        blocks: [
          { type: 'text', text: 'Задание 4 — Математика проекта. Проект имеет 8 разделов. Анита уже сделала 5.' },
          { type: 'list', items: [
            'Осталось: 8 − 5 = ______',
            'Каждый оставшийся раздел — 6 минут. Нужно минут: ______ × 6 = ______',
            '2 дня по 10 минут: 2 × 10 = ______',
            'Хватит ли времени? да / нет',
            'Сколько минут останется или не хватит? ______'
          ] },
          { type: 'text', text: 'Задание 5 — Карточки контента. 5 карточек × 4 фразы; +6 рисунков; −2 длинные фразы.' },
          { type: 'list', items: [
            '5 × 4 = ______ фраз',
            '______ + 6 = ______ всего',
            '______ − 2 = ______ после исправления',
            '18 ÷ 6 = ______ фразы на каждой'
          ] },
          { type: 'text', text: 'Задание 6 — План моего полезного контента. Выбери формат:' },
          { type: 'list', items: [
            '□ постер',
            '□ мини-гайд',
            '□ карточка проверки',
            '□ рисунок-инструкция',
            '□ короткий сценарий объяснения',
            '□ маленькая презентация'
          ] },
          { type: 'list', items: [
            '1. Название проекта: ____________________',
            '2. Кому поможет: ____________________',
            '3. Что объясняет: ____________________',
            '4. 3 главных шага: ____________________',
            '5. Один пример: ____________________',
            '6. Почему это полезно: ____________________',
            '7. Чек-лист автора: честно / понятно / полезно / безопасно',
            '8. Обещание автора: ____________________'
          ] }
        ] },
      { title: 'Проверка и презентация / Check and Present',
        blocks: [
          { type: 'text', text: 'Задание 7 — Финальная проверка безопасности. A = можно оставить, B = нужно спросить родителя, C = убрать из проекта.' },
          { type: 'list', items: [
            '1. Роль «родитель» вместо настоящего имени. ____',
            '2. Настоящий адрес. ____',
            '3. Фраза «спроси взрослого». ____',
            '4. Красивое обещание «это поможет всем всегда». ____',
            '5. Рисунок Нимни. ____',
            '6. Настоящее фото ребёнка. ____',
            '7. Проверочный вопрос «это безопасно?» ____',
            '8. Название школы. ____',
            '9. 3 понятных шага. ____',
            '10. Секретный пароль. ____',
            '11. Добрые слова. ____',
            '12. Показ проекта родителю. ____'
          ] },
          { type: 'text', text: 'Задание 8 — Правописание недели. Напиши 6 слов на выбор: автор, польза, аудитория, черновик, честно, понятно, полезно, безопасно, обещание.' },
          { type: 'list', items: [
            '1. ____________________',
            '2. ____________________',
            '3. ____________________',
            '4. ____________________',
            '5. ____________________',
            '6. ____________________'
          ] },
          { type: 'text', text: 'Задание 9 — Защита проекта. Ответь родителю:' },
          { type: 'list', items: [
            '□ Какой проект ты сделала?',
            '□ Кому он поможет?',
            '□ Что он объясняет?',
            '□ Почему он полезный?',
            '□ Как ты проверила: честно, понятно, полезно, безопасно?'
          ] },
          { type: 'text', text: 'Обещание автора: Я обещаю создавать полезное, честное, понятное и безопасное.' },
          { type: 'text', text: 'Подпись creator: ____________________' },
          { type: 'text', text: 'Parent Check: □ Прочитала слова недели  □ Прочитала фразы автора  □ Решила math review  □ Заполнила 8 разделов проекта  □ Проверила безопасность  □ Провела презентацию родителю.' },
          { type: 'text', text: 'Notebook Mode — если нет принтера, сделай эти задания в тетради.' }
        ] }
    ]
  },
  parentGuide: {
    goal: 'Анита создаёт полезный бумажный creator project и объясняет его родителю.',
    mathGoal: 'Смешанное повторение: вычитание, умножение, деление, время, план проекта.',
    russianGoal: 'Прочитать слова недели и 5 фраз автора.',
    readingWritingGoal: 'Прочитать фразы, написать 6 слов, заполнить 8 разделов проекта.',
    practicalGoal: 'Создать полезный контент и проверить его по creator checklist.',
    parentTheoryCard: {
      title: 'Как провести Авторский проект',
      purpose: 'Помочь родителю провести финальный проект Week 9 без давления и без публикации онлайн.',
      keyMessage: 'Авторский проект — это не пост в соцсети. Это бумажный полезный продукт, который ребёнок показывает родителю.',
      parentScript: [
        '«Сегодня ты создаёшь полезное, а не просто смотришь.»',
        '«Проект должен помочь кому-то понять или сделать что-то.»',
        '«Сначала черновик, потом проверка, потом исправление.»',
        '«Мы не публикуем онлайн. Мы показываем родителю.»',
        '«Creator проверяет: честно, понятно, полезно, безопасно.»'
      ],
      practiceSteps: [
        'Пусть Анита выберет формат.',
        'Помогите выбрать аудиторию: младший ребёнок, семья, Нимни, ученик.',
        'Проверьте 8 разделов.',
        'Проведите короткую презентацию.',
        'Похвалите ясность и пользу, а не идеальность.'
      ],
      doNotSay: [
        'Не говорить: «Это должно быть как настоящее видео.»',
        'Не просить публиковать онлайн.',
        'Не просить реальные имена, адреса, школу или фото.',
        'Не делать проект за ребёнка.'
      ],
      paperOnlyNotes: [
        'Всё выполняется на бумаге или в тетради.',
        'Можно хранить проект в папке курса.',
        'Можно показать семье дома, но не публиковать.'
      ]
    },
    whatThisLessonTeaches: 'Анита учится превращать идею в полезный бумажный продукт.',
    keyMessage: 'Я не только пользователь. Я могу создать полезное.',
    howToExplain: 'Скажите: «Пользователь просто смотрит. Автор думает, кому помочь, делает черновик, проверяет и объясняет.»',
    exampleDialogue:
      'Parent: Какой проект ты выбрала?\nChild: Постер.\nParent: Кому он поможет?\nChild: Ребёнку, который потерялся.\nParent: Что он объясняет?\nChild: Остановиться, попросить помощи, ждать.\nParent: Как ты проверила?\nChild: Честно, понятно, полезно, безопасно.',
    readingSupport: 'Слова «аудитория», «черновик», «обещание» можно читать по частям.',
    russianSpeechGoal: 'Анита объясняет проект минимум 3 русскими фразами.',
    mathAnswerKey:
      'math-project-plan: 1) 3. 2) 18 минут. 3) 20 минут, хватит. 4) 2 минуты останется.\nmath-content-cards: 1) 20. 2) 26. 3) 18. 4) 3.',
    spellingAnswerKey: 'автор\nпольза\nаудитория\nчерновик\nчестно\nпонятно\nполезно\nбезопасно\nобещание',
    answerKey: [
      { taskId: 'reading-review-words', answer: 'Попытка чтения.' },
      { taskId: 'oral-defense-reading', answer: 'Попытка чтения и/или устного произнесения.' },
      { taskId: 'project-topic-choice', answer: 'good: 1,2,3,4,6,8,9,11,12; remove: 5,7,10; parent-check acceptable for 2/11/12.' },
      { taskId: 'math-project-plan', answer: '3; 18; 20 yes; 2 minutes remain.' },
      { taskId: 'math-content-cards', answer: '20; 26; 18; 3.' },
      { taskId: 'creator-project-planner', answer: 'Most 8 sections filled safely.' },
      { taskId: 'creator-safety-final-sort', answer: 'keep: 1,3,5,7,9,11,12; parent check: 4; remove: 2,6,8,10.' },
      { taskId: 'spelling-review', answer: 'Any 6 attempted words.' },
      { taskId: 'speech-creator-presentation', answer: 'Meaningful Russian presentation.' }
    ],
    check: [
      'Анита прочитала слова и фразы.',
      'Анита выбрала тему проекта.',
      'Анита решила math review.',
      'Анита заполнила 8 разделов.',
      'Анита проверила безопасность.',
      'Анита провела презентацию.'
    ],
    spellingCheck: 'Проверить 6 выбранных слов. Исправлять мягко.',
    readingCheck: 'Главное — попытка русского чтения и понимание creator idea.',
    practicalCheck: 'Проект должен быть полезным, бумажным, безопасным и без личных данных.',
    projectCriteria:
      'Project should include: 1) Title. 2) Audience. 3) What it explains. 4) Three steps. 5) One example. 6) Why it is useful. 7) Чек-лист автора. 8) Обещание автора.',
    rubric:
      'Russian reading attempt — 15 points.\nRussian oral presentation — 15 points.\nMath review correctness — 15 points.\nCreator purpose and audience — 15 points.\nSafety/no personal data — 15 points.\nProject completeness — 15 points.\nCreativity/neatness — 5 points.\nEffort and focus — 5 points.',
    commonMistakes: [
      '«Авторский проект надо публиковать.» Правильно: «Нет, это бумажный проект для родителя.»',
      '«Главное, чтобы было красиво.» Правильно: «Главное — польза, ясность, безопасность.»',
      '«Можно использовать настоящий адрес для примера.» Правильно: «Нет, реальные данные не используем.»',
      '«Черновик должен быть идеальным.» Правильно: «Черновик нужен, чтобы улучшать.»'
    ],
    discussionPrompts: [
      'Кому поможет твой проект?',
      'Что человек сможет сделать после твоего проекта?',
      'Что ты исправила после проверки?',
      'Какой вопрос Чек-лист автора был самым важным?'
    ],
    ifEasy: 'Попросить Аниту провести 2-минутную презентацию по-русски.',
    ifDifficult: 'Пусть Анита заполнит только 4 раздела: название, кому поможет, 3 шага, creator promise.',
    rewardGuidance: 'Проектный день: базовая награда 5 нимов. Бонусы за чтение, объяснение и аккуратный проект.',
    tokenReward: 'Нимы — это призовые токены курса, а не оплата.',
    parentOnlyNotes: 'Не публиковать проект. Не использовать личные данные. Не превращать проект в экзамен.',
    safetyNotes: 'Только бумажный проект или тетрадь. Без фото, адреса, школы, пароля, социальных сетей, аккаунтов, публикации или контакта с незнакомцами.'
  },
  reward: { unit: 'nim', unitName: 'ним', base: 5, max: 8, label: 'Награда за проект', display: '5 нимов',
    bonuses: [
      { id: 'reading-attempt', label: 'Бонус за хорошую попытку русского чтения', amount: 1 },
      { id: 'clear-presentation', label: 'Бонус за ясную презентацию родителю', amount: 1 },
      { id: 'neat-project', label: 'Бонус за аккуратный Авторский проект', amount: 1 }
    ] },
  completionRequirements: {
    requiredTaskIds: ['reading-review-words', 'oral-defense-reading', 'project-topic-choice', 'math-project-plan', 'math-content-cards', 'creator-project-planner', 'creator-safety-final-sort', 'spelling-review', 'speech-creator-presentation'],
    allowNotebookCompletion: true
  },
  nextLessonId: 'anita-week-10-day-1'
};

export default day5;
